'use client';

import { HStack } from '@terra/ui-styled-system';
import { Button, Text } from '@terra/ui-design-system';
import { ClipboardPasteIcon, GitCompareIcon } from '@terra/ui-icons';
import { EmptyState } from '../EmptyState';

type ComparerEmptyStateProps = {
  onOpenPasteDialog?: () => void;
};

export function ComparerEmptyState({
  onOpenPasteDialog,
}: ComparerEmptyStateProps) {
  return (
    <EmptyState
      icon={GitCompareIcon}
      title="No items to compare"
      description="Right-click on requests and select 'Send to Comparer', or paste content from clipboard"
      action={
        onOpenPasteDialog ? (
          <HStack gap="2">
            <Button size="xs" variant="outline" onClick={onOpenPasteDialog}>
              <ClipboardPasteIcon size={12} />
              <Text fontSize="xs">Paste from Clipboard</Text>
            </Button>
          </HStack>
        ) : undefined
      }
    />
  );
}
